import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsal } from "@/authConfig";
import '@/styles/theme/theme.scss';
import '@/index.scss';
import App from "./App";

async function main() {
  await initializeMsal();

  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

main().catch((err) => {
  console.error("Failed to initialize MSAL", err);
});